import { Outlet } from "react-router-dom"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { NarrowNavItems, NarrowNavItemsProps } from "./NarrowNavItems"
import { PropsWithChildren } from "react"
import { tailwindPalette } from "../../modules/theme/tailwindPalette"
import { whenPrintingPageOnly, whenPrintingPlainBackground } from "../components/print/printPageOnly"
import { useIsMobile } from "../hooks/useIsMobile"
import { NarrowNavBottomBar } from "./NarrowNavBottomBar"

const useStyles = makeStyles()((theme) => ({
    container: {
        backgroundColor: tailwindPalette.blue[50],
        minHeight: "100vh",
        position: "relative",
        ...whenPrintingPageOnly({
            minHeight: "auto",
            printColorAdjust: "exact",
        }),
        ...whenPrintingPlainBackground({
            backgroundColor: theme.palette.common.white,
        }),
    },
    mainContent: {
        display: "flex",
        width: "100%",
    },
    pageContainer: {
        padding: "1rem 2rem",
        width: "100%",
        marginLeft: "7rem",
        [theme.breakpoints.down("sm")]: {
            padding: "1rem",
            marginLeft: 0,
        },
        ...whenPrintingPageOnly({
            padding: ".75rem 1.25rem 0",
            marginLeft: 0,
        }),
    },
}))

export function NarrowNavLayout({ navItems, children }: PropsWithChildren<NarrowNavItemsProps>) {
    const { classes } = useStyles()
    const isMobile = useIsMobile()

    return (
        // a column on phones, so the content fills the screen and the sticky bottom bar starts at its end
        <Box className={classes.container} display={{ xs: "flex", sm: "block" }} flexDirection="column">
            {children}
            <Box className={classes.mainContent} flexGrow={1}>
                {!isMobile && <NarrowNavItems navItems={navItems} />}
                <Box className={classes.pageContainer}>
                    <Outlet />
                </Box>
            </Box>
            {isMobile && <NarrowNavBottomBar navItems={navItems} />}
        </Box>
    )
}
